import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import s from './TwoColumnLayout.scss';
import { useConditionalSticky } from '../../hooks';

export interface TwoColumnsLayoutProps {
  mainContent: React.ReactNode;
  sideContent: React.ReactNode;
  mainContentSpan?: number;
  mainCellStyle?: React.CSSProperties;
  sideCellStyle?: React.CSSProperties;
}

export const TwoColumnLayout: FC<TwoColumnsLayoutProps> = ({
  mainContent,
  sideContent,
  mainContentSpan = 8,
  mainCellStyle,
  sideCellStyle,
}) => {
  const { mainCellRef, sideCellRef, shouldStick } = useConditionalSticky(mainContent, sideContent);

  const safeMainSpan = Math.min(Math.max(mainContentSpan, 1), 11);
  const sideSpan = 12 - safeMainSpan;
  const sideWidth = sideCellStyle?.maxWidth || `${(sideSpan / 12) * 100}%`;

  return (
    <Box className={s.layoutWrapper} display="flex" verticalAlign="top" width="100%">
      <Box ref={mainCellRef} className={s.mainCell} width="auto" height="100%" style={mainCellStyle} flex={1}>
        {mainContent}
      </Box>

      <Box
        ref={sideCellRef}
        className={`${s.sideCell} ${shouldStick ? s.sticky : ''}`}
        width={sideWidth}
        style={sideCellStyle}
      >
        <div className={s.sideScrollWrapper}>{sideContent}</div>
      </Box>
    </Box>
  );
};
